export const OAUTH_ENDPOINTS = {
    sendEmailLogin: '/realms/master/magic-link-login',
    token: '/realms/master/protocol/openid-connect/token',
}
